// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"823a2503","367":"93a16da7","467":"bb19b7f8","956":"ae776711"}[chunkId] + ".chunk.js";
};